import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — El peso que seguís cargando',
  subtitle: 'Identificá lo que te afecta hoy',
  accent: 'border-l-blue-500',
  items: ['Identificación de patrones heredados', 'El impacto de la infancia en tu presente', 'Reconocimiento de cargas emocionales', 'Mapa de tu relación actual', 'Primeros pasos hacia la conciencia']
}, {
  icon: '🟣',
  title: 'Tomo 2 — Lo que nunca se dijo',
  subtitle: 'Liberá lo que quedó guardado',
  accent: 'border-l-purple-500',
  items: ['Expresión emocional segura', 'Cartas que no necesitan enviarse', 'Validación de tu propia historia', 'Desahogo de palabras contenidas', 'Técnicas de liberación emocional']
}, {
  icon: '🔴',
  title: 'Tomo 3 — Entender sin justificar',
  subtitle: 'Comprendé sin invalidarte',
  accent: 'border-l-red-500',
  items: ['Mirada sistémica de la familia', 'La historia detrás de tus padres', 'Diferencia entre perdonar y entender', 'Protección de tu bienestar emocional', 'Rompiendo el ciclo de repetición']
}, {
  icon: '🟠',
  title: 'Tomo 4 — Soltar sin necesidad de perdón perfecto',
  subtitle: 'Liberate sin depender del otro',
  accent: 'border-l-orange-500',
  items: ['Autonomía emocional real', 'Soltar la expectativa de cambio ajeno', 'El perdón como acto personal', 'Cierre de ciclos pendientes', 'Paz interior como prioridad']
}, {
  icon: '🟢',
  title: 'Tomo 5 — Hablar desde otro lugar',
  subtitle: 'Comunicate sin carga emocional',
  accent: 'border-l-green-500',
  items: ['Comunicación no violenta aplicada', 'Gestión de conversaciones difíciles', 'Escucha activa sin reactividad', 'Expresión de necesidades claras', 'Manejo de conflictos recurrentes']
}, {
  icon: '🟡',
  title: 'Tomo 6 — Una nueva relación posible',
  subtitle: 'Construí un vínculo distinto',
  accent: 'border-l-yellow-400',
  items: ['Definición de nuevos acuerdos', 'Límites saludables y firmes', 'Preservación de tu espacio vital', 'Relación desde la adultez', 'Sostenimiento del cambio a largo plazo']
}];
const features = ['ejercicios prácticos', 'herramientas emocionales', 'guías paso a paso', 'aplicación real', 'resultados desde el día uno'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="py-5 px-5 bg-[#000000]" data-id="element-295">
      <div className="max-w-xl mx-auto" data-id="element-296">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-297">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-298">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-299">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-slate-900 border border-slate-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-300">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-301">
                  <span className="text-2xl flex-shrink-0" data-id="element-302">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-303">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-304">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-slate-500" data-id="element-305">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-306" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-307" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-308">
                    <div className="space-y-2" data-id="element-309">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-310">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-311" />
                          <span className="text-xs text-slate-400" data-id="element-312">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 mb-10" data-id="element-313">
          <h3 className="text-base font-bold text-center mb-4 text-[#FBBE24]" data-id="element-314">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-315">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-316">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-317" />
                <span className="text-sm text-slate-300 font-medium" data-id="element-318">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}